import { reactive } from 'vue'
import { jurisdictionList } from '@/utils/constData'
import { formatTime } from '@/utils/time'
export const headers = reactive([
  {
    title: 'Company',
    showNumber: true,
    htmlDomFunc: ({ entityName, enName }: any) => {
      if (!entityName && !enName) {
        return '<div class="value">No records found</div>'
      }
      return `
      <div class="value">
        <div>${entityName || ''}</div>
        <div>${enName || ''}</div>
      </div>`
    }
  },
  {
    title: 'Jurisdiction',
    width: 140,
    htmlDomFunc: ({ countryCode }: any) => {
      const countryInfo = jurisdictionList.find(item => item.code === countryCode)
      if (!countryInfo?.code || !countryCode) return '<div class="value">No records found</div>'
      return `
        <div class="value">
          <img src="${countryInfo.src}"  style="width: 40px;"/>
          <div>${countryInfo.infoKey}</div>
        </div>`
    }
  },
  {
    title: 'Start Date',
    htmlDomFunc: ({ createTime }: any) => {
      return formatTime(createTime)
    },
    width: 150
  },
  {
    title: 'Action',
    width: 80
  }
])
